import { g as J } from "../_commonjsHelpers-DaMA6jEr.mjs";
var q = {}, W = {}, R = {};
(function(g) {
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = void 0;
  var h = function() {
    for (var b = arguments.length, A = new Array(b), w = 0; w < b; w++)
      A[w] = arguments[w];
    if (typeof window < "u") {
      var o;
      typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
        window.dataLayer.push(arguments);
      }), (o = window).gtag.apply(o, A);
    }
  }, v = h;
  g.default = v;
})(R);
var F = {};
(function(g) {
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = w;
  var h = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  function v(o) {
    return o.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(u, c, l) {
      return c > 0 && c + u.length !== l.length && u.search(h) > -1 && l.charAt(c - 2) !== ":" && (l.charAt(c + u.length) !== "-" || l.charAt(c - 1) === "-") && l.charAt(c - 1).search(/[^\s-]/) < 0 ? u.toLowerCase() : u.substr(1).search(/[A-Z]|\../) > -1 ? u : u.charAt(0).toUpperCase() + u.substr(1);
    });
  }
  function S(o) {
    return typeof o == "string" && o.indexOf("@") !== -1;
  }
  var b = "REDACTED (Potential Email Address)";
  function A(o) {
    return S(o) ? (console.warn("This arg looks like an email address, redacting."), b) : o;
  }
  function w() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, l = o || "";
    return u && (l = v(o)), c && (l = A(l)), l;
  }
})(F);
(function(g) {
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = g.GA4 = void 0;
  var h = w(R), v = w(F), S = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], b = ["title", "location"], A = ["page", "hitType"];
  function w(r) {
    return r && r.__esModule ? r : { default: r };
  }
  function o(r, e) {
    if (r == null) return {};
    var t = u(r, e), n, a;
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(r);
      for (a = 0; a < i.length; a++)
        n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }
  function u(r, e) {
    if (r == null) return {};
    var t = {}, n = Object.keys(r), a, i;
    for (i = 0; i < n.length; i++)
      a = n[i], !(e.indexOf(a) >= 0) && (t[a] = r[a]);
    return t;
  }
  function c(r) {
    "@babel/helpers - typeof";
    return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
      return typeof e;
    } : function(e) {
      return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, c(r);
  }
  function l(r) {
    return P(r) || O(r) || T(r) || C();
  }
  function C() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function O(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
  }
  function P(r) {
    if (Array.isArray(r)) return G(r);
  }
  function E(r, e) {
    var t = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(r);
      e && (n = n.filter(function(a) {
        return Object.getOwnPropertyDescriptor(r, a).enumerable;
      })), t.push.apply(t, n);
    }
    return t;
  }
  function _(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e] != null ? arguments[e] : {};
      e % 2 ? E(Object(t), !0).forEach(function(n) {
        d(r, n, t[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : E(Object(t)).forEach(function(n) {
        Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
      });
    }
    return r;
  }
  function Q(r, e) {
    return V(r) || k(r, e) || T(r, e) || U();
  }
  function U() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function T(r, e) {
    if (r) {
      if (typeof r == "string") return G(r, e);
      var t = Object.prototype.toString.call(r).slice(8, -1);
      if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return G(r, e);
    }
  }
  function G(r, e) {
    (e == null || e > r.length) && (e = r.length);
    for (var t = 0, n = new Array(e); t < e; t++) n[t] = r[t];
    return n;
  }
  function k(r, e) {
    var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (t != null) {
      var n, a, i, f, s = [], p = !0, m = !1;
      try {
        if (i = (t = t.call(r)).next, e !== 0) for (; !(p = (n = i.call(t)).done) && (s.push(n.value), s.length !== e); p = !0) ;
      } catch (y) {
        m = !0, a = y;
      } finally {
        try {
          if (!p && t.return != null && (f = t.return(), Object(f) !== f)) return;
        } finally {
          if (m) throw a;
        }
      }
      return s;
    }
  }
  function V(r) {
    if (Array.isArray(r)) return r;
  }
  function B(r, e) {
    if (!(r instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function H(r, e) {
    for (var t = 0; t < e.length; t++) {
      var n = e[t];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, M(n.key), n);
    }
  }
  function K(r, e, t) {
    return H(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
  }
  function d(r, e, t) {
    return e = M(e), e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
  }
  function M(r) {
    var e = Z(r, "string");
    return c(e) === "symbol" ? e : String(e);
  }
  function Z(r, e) {
    if (c(r) !== "object" || r === null) return r;
    var t = r[Symbol.toPrimitive];
    if (t !== void 0) {
      var n = t.call(r, e || "default");
      if (c(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(r);
  }
  var L = /* @__PURE__ */ function() {
    function r() {
      var e = this;
      B(this, r), d(this, "reset", function() {
        e.isInitialized = !1, e._testMode = !1, e._currentMeasurementId, e._hasLoadedGA = !1, e._isQueuing = !1, e._queueGtag = [];
      }), d(this, "_gtag", function() {
        for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
          n[a] = arguments[a];
        e._testMode || e._isQueuing ? e._queueGtag.push(n) : h.default.apply(void 0, n);
      }), d(this, "_loadGA", function(t, n) {
        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
        if (!(typeof window > "u" || typeof document > "u") && !e._hasLoadedGA) {
          var i = document.createElement("script");
          i.async = !0, i.src = "".concat(a, "?id=").concat(t), n && i.setAttribute("nonce", n), document.body.appendChild(i), window.dataLayer = window.dataLayer || [], window.gtag = function() {
            window.dataLayer.push(arguments);
          }, e._hasLoadedGA = !0;
        }
      }), d(this, "_toGtagOptions", function(t) {
        if (t) {
          var n = {
            // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
            // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            // must be in set method?
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            // https://support.google.com/analytics/answer/9050852?hl=en
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
          }, a = Object.entries(t).reduce(function(i, f) {
            var s = Q(f, 2), p = s[0], m = s[1];
            return n[p] ? i[n[p]] = m : i[p] = m, i;
          }, {});
          return a;
        }
      }), d(this, "initialize", function(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!t)
          throw new Error("Require GA_MEASUREMENT_ID");
        var a = typeof t == "string" ? [{
          trackingId: t
        }] : t;
        e._currentMeasurementId = a[0].trackingId;
        var i = n.gaOptions, f = n.gtagOptions, s = n.nonce, p = n.testMode, m = p === void 0 ? !1 : p, y = n.gtagUrl;
        if (e._testMode = m, m || e._loadGA(e._currentMeasurementId, s, y), e.isInitialized || (e._gtag("js", /* @__PURE__ */ new Date()), a.forEach(function(I) {
          var D = _(_(_({}, e._toGtagOptions(_(_({}, i), I.gaOptions))), f), I.gtagOptions);
          Object.keys(D).length ? e._gtag("config", I.trackingId, D) : e._gtag("config", I.trackingId);
        })), e.isInitialized = !0, !m) {
          var j = l(e._queueGtag);
          for (e._queueGtag = [], e._isQueuing = !1; j.length; ) {
            var z = j.shift();
            e._gtag.apply(e, l(z)), z[0] === "get" && (e._isQueuing = !0);
          }
        }
      }), d(this, "set", function(t) {
        if (!t) {
          console.warn("`fieldsObject` is required in .set()");
          return;
        }
        if (c(t) !== "object") {
          console.warn("Expected `fieldsObject` arg to be an Object");
          return;
        }
        Object.keys(t).length === 0 && console.warn("empty `fieldsObject` given to .set()"), e._gaCommand("set", t);
      }), d(this, "_gaCommandSendEvent", function(t, n, a, i, f) {
        e._gtag("event", n, _(_({
          event_category: t,
          event_label: a,
          value: i
        }, f && {
          non_interaction: f.nonInteraction
        }), e._toGtagOptions(f)));
      }), d(this, "_gaCommandSendEventParameters", function() {
        for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
          n[a] = arguments[a];
        if (typeof n[0] == "string")
          e._gaCommandSendEvent.apply(e, l(n.slice(1)));
        else {
          var i = n[0], f = i.eventCategory, s = i.eventAction, p = i.eventLabel, m = i.eventValue;
          i.hitType;
          var y = o(i, S);
          e._gaCommandSendEvent(f, s, p, m, y);
        }
      }), d(this, "_gaCommandSendTiming", function(t, n, a, i) {
        e._gtag("event", "timing_complete", {
          name: n,
          value: a,
          event_category: t,
          event_label: i
        });
      }), d(this, "_gaCommandSendPageview", function(t, n) {
        if (n && Object.keys(n).length) {
          var a = e._toGtagOptions(n), i = a.title, f = a.location, s = o(a, b);
          e._gtag("event", "page_view", _(_(_(_({}, t && {
            page_path: t
          }), i && {
            page_title: i
          }), f && {
            page_location: f
          }), s));
        } else t ? e._gtag("event", "page_view", {
          page_path: t
        }) : e._gtag("event", "page_view");
      }), d(this, "_gaCommandSendPageviewParameters", function() {
        for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
          n[a] = arguments[a];
        if (typeof n[0] == "string")
          e._gaCommandSendPageview.apply(e, l(n.slice(1)));
        else {
          var i = n[0], f = i.page;
          i.hitType;
          var s = o(i, A);
          e._gaCommandSendPageview(f, s);
        }
      }), d(this, "_gaCommandSend", function() {
        for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
          n[a] = arguments[a];
        var i = typeof n[0] == "string" ? n[0] : n[0].hitType;
        switch (i) {
          case "event":
            e._gaCommandSendEventParameters.apply(e, n);
            break;
          case "pageview":
            e._gaCommandSendPageviewParameters.apply(e, n);
            break;
          case "timing":
            e._gaCommandSendTiming.apply(e, l(n.slice(1)));
            break;
          case "screenview":
          case "transaction":
          case "item":
          case "social":
          case "exception":
            console.warn("Unsupported send command: ".concat(i));
            break;
          default:
            console.warn("Send command doesn't exist: ".concat(i));
        }
      }), d(this, "_gaCommandSet", function() {
        for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
          n[a] = arguments[a];
        typeof n[0] == "string" && (n[0] = d({}, n[0], n[1])), e._gtag("set", e._toGtagOptions(n[0]));
      }), d(this, "_gaCommand", function(t) {
        for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
          a[i - 1] = arguments[i];
        switch (t) {
          case "send":
            e._gaCommandSend.apply(e, a);
            break;
          case "set":
            e._gaCommandSet.apply(e, a);
            break;
          default:
            console.warn("Command doesn't exist: ".concat(t));
        }
      }), d(this, "ga", function() {
        for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
          n[a] = arguments[a];
        if (typeof n[0] == "string")
          e._gaCommand.apply(e, n);
        else {
          var i = n[0];
          e._gtag("get", e._currentMeasurementId, "client_id", function(f) {
            e._isQueuing = !1;
            var s = e._queueGtag;
            for (i({
              get: function(y) {
                return y === "clientId" ? f : y === "trackingId" ? e._currentMeasurementId : y === "apiVersion" ? "1" : void 0;
              }
            }); s.length; ) {
              var p = s.shift();
              e._gtag.apply(e, l(p));
            }
          }), e._isQueuing = !0;
        }
        return e.ga;
      }), d(this, "event", function(t, n) {
        if (typeof t == "string")
          e._gtag("event", t, e._toGtagOptions(n));
        else {
          var a = t.action, i = t.category, f = t.label, s = t.value, p = t.nonInteraction, m = t.transport;
          if (!i || !a) {
            console.warn("args.category AND args.action are required in event()");
            return;
          }
          var y = {
            hitType: "event",
            eventCategory: (0, v.default)(i),
            eventAction: (0, v.default)(a)
          };
          f && (y.eventLabel = (0, v.default)(f)), typeof s < "u" && (typeof s != "number" ? console.warn("Expected `args.value` arg to be a Number.") : y.eventValue = s), typeof p < "u" && (typeof p != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : y.nonInteraction = p), typeof m < "u" && (typeof m != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(m) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), y.transport = m)), e._gaCommand("send", y);
        }
      }), d(this, "send", function(t) {
        e._gaCommand("send", t);
      }), this.reset();
    }
    return K(r, [{
      key: "gtag",
      value: function() {
        this._gtag.apply(this, arguments);
      }
    }]), r;
  }();
  g.GA4 = L;
  var x = new L();
  g.default = x;
})(W);
(function(g) {
  function h(o) {
    "@babel/helpers - typeof";
    return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, h(o);
  }
  Object.defineProperty(g, "__esModule", {
    value: !0
  }), g.default = g.ReactGAImplementation = void 0;
  var v = b(W);
  function S(o) {
    if (typeof WeakMap != "function") return null;
    var u = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (S = function(C) {
      return C ? c : u;
    })(o);
  }
  function b(o, u) {
    if (o.__esModule)
      return o;
    if (o === null || h(o) !== "object" && typeof o != "function")
      return { default: o };
    var c = S(u);
    if (c && c.has(o))
      return c.get(o);
    var l = {}, C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var O in o)
      if (O !== "default" && Object.prototype.hasOwnProperty.call(o, O)) {
        var P = C ? Object.getOwnPropertyDescriptor(o, O) : null;
        P && (P.get || P.set) ? Object.defineProperty(l, O, P) : l[O] = o[O];
      }
    return l.default = o, c && c.set(o, l), l;
  }
  var A = v.GA4;
  g.ReactGAImplementation = A;
  var w = v.default;
  g.default = w;
})(q);
const X = /* @__PURE__ */ J(q), N = (g, h = "local", v) => {
  if (!v) {
    console.warn("GA_MEASUREMENT_ID is not set. Google Analytics will not be initialized.");
    return;
  }
  h === "staging" || h === "production" ? X.initialize(v, {
    // Use gaOptions to send custom dimensions with every GA event except initial_page_view.
    // gtagOptions could be used to send custom dimensions to initial_page_view only, if desired.
    gaOptions: {
      // custom dimensions to report
      scripps_brand: g,
      scripps_platform: "Web"
    }
  }) : console.info("** Note: Google Analytics is only initialized in staging and production environments. **");
};
export {
  N as initializeAnalytics
};
